var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgExportCompleted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    stroke: "#42BE65",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77301 11.9489L9.12512 12.2979L9.47711 11.9487L13.7559 7.70457L14.0402 7.98704L9.12516 12.8584L6.71079 10.4633L6.99308 10.1846L8.77301 11.9489Z",
    fill: "#42BE65",
    stroke: "#42BE65"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgExportCompleted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/export-completed.28907e1bfd8161970484baf1f14efa13.svg";